/* eslint-disable no-useless-constructor */
// модель для установки лайков аромату статуса.
// т.к. в текущей реализации универсального метода лайков
// использовать стандартную модель StatusPerfumes невозможно

import Model from '@/models/Model'

export default class AccountStatusPerfumes extends Model {
    resource() {
        return 'accounts/status-perfumes'
    }

    primaryKey() {
        return 'code'
    }
}
